import React from "react";

import { colors } from "../../../../cssConstants";
import { ensureHexValue } from "../../../common/utils";
import AnalyticCard, { DEFAULT_ERROR_MESSAGE } from "../AnalyticCard/AnalyticCard";
import {
  CenterMessage,
  Column,
  Main,
  StateLabel,
  StateProgress,
  StyledProgress,
  TaskCount
} from "../common/styledComponents";

import { RoleStatistic, useOpenStateTaskRoleStatistics } from "./queries";

export function OpenStateTaskRoleStatisticsView({
  statistics,
  className
}: {
  statistics: RoleStatistic[];
  className?: string;
}) {
  const totalTaskCount = statistics.reduce((prev, current) => {
    return prev + current.taskCount;
  }, 0);

  return (
    <Main className={className}>
      <Column>
        {statistics.map(stat => (
          <StateLabel key={`${stat.role.id}-label`}>{stat.role.name}</StateLabel>
        ))}
      </Column>
      <Column>
        {statistics.map(stat => (
          <TaskCount key={`${stat.role.id}-count`}>{stat.taskCount}</TaskCount>
        ))}
      </Column>
      <StateProgress>
        {statistics.map(stat => (
          <StyledProgress
            key={`${stat.role.id}-progress`}
            strokeWidth={10}
            strokeColor={ensureHexValue(colors.primaryColor)}
            percent={(stat.taskCount / totalTaskCount) * 100}
            showInfo={false}
          />
        ))}
      </StateProgress>
    </Main>
  );
}

export default function OpenStateTaskRoleStatistics({
  queueId,
  actionText,
  className,
  onActionClick = () => null
}: {
  queueId?: string;
  actionText?: string;
  className?: string;
  onActionClick?: () => void;
}) {
  const { data, loading, error } = useOpenStateTaskRoleStatistics({
    variables: { queueId: queueId! },
    skip: !queueId,
    fetchPolicy: "cache-and-network"
  });

  return (
    <AnalyticCard
      title="Open tasks assigned to role"
      loading={loading}
      errorMessage={error ? DEFAULT_ERROR_MESSAGE : undefined}
      className={className}
      headerActionText={actionText}
      onHeaderActionClick={() => onActionClick()}
    >
      {data?.openStateTasksAssignedRole.length === 0 && (
        <CenterMessage>No assigned tasks</CenterMessage>
      )}
      {data?.openStateTasksAssignedRole.length !== 0 && (
        <OpenStateTaskRoleStatisticsView
          statistics={data?.openStateTasksAssignedRole || []}
        />
      )}
    </AnalyticCard>
  );
}
